import { getPath } from '@/router/common'

const baseUrl = {
  title: '微信公告设置',
  path: 'WXAccount'
}

export default [
  {
    path: getPath('WeiXinNoticeIndex', baseUrl),
    name: 'WeiXinNoticeIndex',
    component: () =>
      import(
        /* webpackChunkName: "WeiXinNoticeIndex" */ '@/views/wXAccount/weiXinNoticeIndex/index.vue'
      ),
    meta: {
      title: '微信公告设置'
    }
  },
  {
    path: getPath('DialogNotice', baseUrl),
    name: 'DialogNotice',
    component: () =>
      import(
        /* webpackChunkName: "DialogNotice" */ '@/views/wXAccount/dialogNotice/index.vue'
      ),
    meta: {
      title: '微信公告设置新增'
    }
  },
  {
    path: getPath('WXUserAccountList', baseUrl),
    name: 'WXAccount_WXUserAccountList',
    component: () => import(/* webpackChunkName: "WXAccount_WXUserAccountList" */ '@/views/wXAccount/wXUserAccountList/index.vue'),
    meta: {
      title: '微信用户信息'
    }
  },
  {
    path: getPath('WithdrawalList', baseUrl),
    name: 'WXAccount_WithdrawalList',
    component: () => import(/* webpackChunkName: "WXAccount_WithdrawalList" */ '@/views/wXAccount/withdrawalList/index.vue'),
    meta: {
      title: '账户提现'
    }
  },
  {
    path: getPath('AccountDetailList', baseUrl),
    name: 'WXAccount_AccountDetailList',
    component: () => import(/* webpackChunkName: "WXAccount_AccountDetailList" */ '@/views/wXAccount/accountDetailList/index.vue'),
    meta: {
      title: '账户流水明细'
    }
  },
  {
    path: getPath('WxCollectionRecord', baseUrl),
    name: 'WXAccount_WxCollectionRecord',
    component: () => import(/* webpackChunkName: "WXAccount_WxCollectionRecord" */ '@/views/wXAccount/wxCollectionRecord/index.vue'),
    meta: {
      title: '微信收付款记录'
    }
  },
  {
    path: getPath('EditSendAddress', baseUrl),
    name: 'WXAccount_EditSendAddress',
    component: () => import(/* webpackChunkName: "WXAccount_EditSendAddress" */ '@/views/wXAccount/editSendAddress/index.vue'),
    meta: {
      title: '发货信息|收货信息'
    }
  },
  {
    path: getPath('WeiXinLbtIndex', baseUrl),
    name: 'WeiXinLbtIndex',
    component: () =>
      import(
        /* webpackChunkName: "WeiXinLbtIndex" */ '@/views/wXAccount/weiXinLbtIndex/index.vue'
      ),
    meta: {
      title: '轮播图设置'
    }
  },
  {
    path: getPath('DialogLbt', baseUrl),
    name: 'WXAccountDialogLbt',
    component: () =>
      import(
        /* webpackChunkName: "WXAccountDialogLbt" */ '@/views/wXAccount/dialogLbt/index.vue'
      ),
    meta: {
      title: '轮播图新增修改'
    }
  },
  {
    path: '/DistributionSetting_80799/Index',
    name: 'DistributionSetting_80799Index',
    component: () =>
      import(
        /* webpackChunkName: "DistributionSetting_80799Index" */ '@/views/distributionSetting_80799/index/index.vue'
      ),
    meta: {
      title: '分销佣金设置'
    }
  },
  {
    path: '/DistributionSetting_80799/AddOrEditPage',
    name: 'DistributionSetting_80799AddOrEditPage',
    component: () =>
      import(
        /* webpackChunkName: "DistributionSetting_80799AddOrEditPage" */ '@/views/distributionSetting_80799/addOrEditPage/index.vue'
      ),
    meta: {
      title: '分销佣金设置新增'
    }
  },
  {
    path: '/TydSign/Index',
    name: 'TydSignIndex',
    component: () => import(/* webpackChunkName: "TydSignIndex" */ '@/views/tydSign/index/index.vue'),
    meta: {
      title: '托运单标记设置'
    }
  }
]
